import baseTheme from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import * as React from "react";
import styled, { css } from "styled-components";

export type ContainerProps = MobiusStyledComponentProps<
    "div",
    {
        /** CSS value of the background. */
        background?: string;
        /** CSS string or styled-components function to be injected into this component. */
        css?: StyledProp<ContainerProps>;
        /** The amount of padding inside the Page, in pixels. */
        padding?: number[];
        fullWidth?: boolean;
        fluid?: boolean;
    }
>;

export const StyledContainer = styled.div<Pick<ContainerProps, "padding" | "fullWidth" | "background" | "fluid">>`
    ${({ padding = [0, 0, 0, 0, 0], theme, fullWidth, background, fluid }) => {
        const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
        const containedWidth = breakpointMediaQueries(theme, [
            css`
                max-width: ${maxWidths[1]}px;
                padding-left: ${(padding && padding[1]) || 0}px;
                padding-right: ${(padding && padding[1]) || 0}px;
            `,
            css`
                max-width: ${maxWidths[1]}px;
                padding-left: ${(padding && padding[1]) || 0}px;
                padding-right: ${(padding && padding[1]) || 0}px;
            `,
            css`
                max-width: ${maxWidths[2]}px;
                padding-left: ${(padding && padding[1]) || 0}px;
                padding-right: ${(padding && padding[1]) || 0}px;
            `,
            css`
                max-width: ${maxWidths[3]}px;
                padding-left: ${(padding && padding[1]) || 0}px;
                padding-right: ${(padding && padding[1]) || 0}px;
            `,
            css`
                max-width: ${maxWidths[4]}px;
                padding-left: ${(padding && padding[1]) || 0}px;
                padding-right: ${(padding && padding[1]) || 0}px;
            `,
        ]);
        return css`
            margin: 0 auto;
            background: ${resolveColor(background, theme)};
            ${fullWidth
                ? `max-width: 100%;& > div {margin: 0 auto;${fluid ? `max-width: 100%;` : containedWidth}}`
                : containedWidth}
        `;
    }}

    ${injectCss}
`;
export const Container: React.FC<ContainerProps> = props => <StyledContainer {...props} />;
